import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#draggable" }),
  /*#__PURE__*/_createTextVNode(" Draggable ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" You can drag and drop Tree nodes by adding a "),
  /*#__PURE__*/_createVNode("code", null, "draggable"),
  /*#__PURE__*/_createTextVNode(" attribute. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_tree, {
        data: _ctx.data,
        "node-key": "id",
        "default-expand-all": "",
        onNodeDragStart: _ctx.handleDragStart,
        onNodeDragEnter: _ctx.handleDragEnter,
        onNodeDragLeave: _ctx.handleDragLeave,
        onNodeDragOver: _ctx.handleDragOver,
        onNodeDragEnd: _ctx.handleDragEnd,
        onNodeDrop: _ctx.handleDrop,
        draggable: "",
        "allow-drop": _ctx.allowDrop,
        "allow-drag": _ctx.allowDrag
      }, null, 8, ["data", "onNodeDragStart", "onNodeDragEnter", "onNodeDragLeave", "onNodeDragOver", "onNodeDragEnd", "onNodeDrop", "allow-drop", "allow-drag"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code10), 1)
        ]),
        _: 1
      })
    ])
  ]))
}